export default __webpack_public_path__ + "static/dance_card_icon-eacc0a040a589f1dcc3f084c5530a49f.jpg";